import React from 'react';
import Revelr from 'configs';
import EventLocation from 'components/eventLocation';

export default React.createClass({
    contextTypes: {
        router: React.PropTypes.object,
    },

    handleEventClick(eventId) {
        this.context.router.push('/events/' + eventId);
    },

    render() {
        const event = this.props.event;

        return (
            <div className={event.unread_messages ? 'event-card new' : 'event-card'} key={event.id} onClick={this.handleEventClick.bind(this, event.id)}>
                <div className="event-details">
                    <div className="event-title">{event.title}</div>
                    <div className="event-location">{event.event_type ? `${event.event_type}, ` : ''}<EventLocation location={event.location || event.location_list} /></div>
                </div>

                <p className="event-date">{event.date.format(Revelr.abbreviatedDateFormat)}</p>
            </div>
        );
    },
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/eventCard.jsx